import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[appActionsHeaderFilters]',
})
export class ActionsHeaderFiltersDirective {
  public templateRef = inject(TemplateRef<any>);
}
